// Render markdown bằng `marked`.
//
// KHÔNG tự viết parser. Lần trước viết tay một parser riêng — sai. Parser
// markdown tự viết là chỗ dễ hỏng âm thầm nhất trong dự án: hiện được thì
// câu nào có `**` lạ, `1.` trong nội dung y khoa, hoặc `x^2` là ra markup rác,
// và người học tưởng app lỗi. `marked` đã xử lý hết, có test.
//
// Cấu hình duy nhất: BỎ token HTML thô.
//
// VÌ SAO BỎ, KHÔNG PHẢI CHO PHÉP
// 1. Nội dung kho có `<` là PHÉP SO SÁNH, không phải HTML: `SpO2 < 90%`,
//    `cân nặng > 2.000 g`. `marked` tự escape `<` trong text nên phần này an
//    toàn; nhưng nếu để HTML thô lọt qua thì đó là đường chèn thẻ/JS — không
//    cần thiết vì kho không dùng HTML ở đâu cả.
// 2. Quan trọng hơn: file nguồn có comment `<!-- tài liệu đối chiếu ... -->`,
//    và nó LỌT vào cột `takeaway` của cả 5470 câu. Markdown không hiển thị
//    comment — nên bỏ token html là đúng chuẩn, và nó giải luôn chỗ dính này.
//    (Nguyên nhân gốc nằm ở `section()` trong internal/importq, đã vá bên đó.)
//
// marked trả về chuỗi HTML nên phải dùng dangerouslySetInnerHTML. Đây là
// điểm duy nhất trong app có innerHTML — lý do chấp nhận được: đầu vào là nội
// dung do team nhập qua `qbank`, không có người dùng nhập, và mọi token HTML
// thô đã bị loại ở trên.

import { marked } from 'marked'

// Nguồn viết gạch đầu dòng bằng ký tự `•`, không phải `-`. Đó là ký tự trang
// trí, KHÔNG phải cú pháp markdown, nên `marked` không hiểu và sẽ in thẳng ra
// text — mất hẳn thụt lề treo, mà đoạn "Vì sao không phải phương án khác" dài
// thì dòng 2 lệch hẳn sang phải so với dòng 1. Đổi `•` thành `-` trước khi
// parse là sửa đúng ở đúng tầng: đây là chuẩn hoá cú pháp đầu vào, không phải
// tự dựng markdown.
//
// `•` phải ở ĐẦU DÒNG và sau nó phải có khoảng trắng. Không có điều kiện
// thứ hai thì "39–40°C" hay "tỉ số A•B" trong nội dung y khoa cũng bị đổi.
const RE_BULLET_CHAR = /^\s*•\s+/gm

marked.use({
  gfm: true,
  breaks: false,
  renderer: {
    // Bỏ mọi khối HTML thô, gồm cả comment. Hàm mặc định trả về chính thẻ đó.
    html: () => '',
  },
})

/** Chuỗi HTML đã render, dùng cho dangerouslySetInnerHTML. */
export function mdToHtml(src: string): string {
  return marked.parse(src.replace(RE_BULLET_CHAR, '- '), { async: false }) as string
}

// `marked` luôn bọc kết quả trong `<p>`. Trong thẻ `<span>` (phương án trả lời)
// hoặc `<h2>` (câu hỏi) thì `<p>` lồng bên trong là HTML không hợp lệ, và
// `display:block` phá luôn căn giữa dọc của nút. Với nội dung một dòng thì
// `<p>` chỉ là vỏ vô nghĩa — bóc ra, giữ nguyên phần bên trong.
const RE_ONE_P = /^<p>([\s\S]*)<\/p>\s*$/

/** Markdown cho nội dung nằm ngay trong một thẻ đơn, không sinh khối mới. */
export function mdToHtmlInline(src: string): string {
  const html = mdToHtml(src)
  const m = RE_ONE_P.exec(html)
  // Chỉ bóc khi toàn bộ output đúng MỘT đoạn `<p>…</p>`. Nếu có `<ul>`/
  // `<ol>` bên trong thì giữ nguyên, không cắt rách.
  return m ? m[1] : html
}
